//https://preview.themeforest.net/item/landrick-vuejs-landing-page-template/full_screen_preview/28733184
//import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

//Vue.config.productionTip = false

import "../public/css/materialdesignicons.min.css";
//import 'swiper/swiper-bundle.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
//import 'bootstrap-vue-next/dist/bootstrap-vue.css'

import {createBootstrap} from 'bootstrap-vue-next'
import { BCard, BCollapse } from 'bootstrap-vue-next'
var VueScrollTo = require('vue-scrollto');
import Scrollspy from 'vue3-scroll-spy';
//import VueYoutube from 'vue-youtube'
//import vueVimeoPlayer from 'vue-vimeo-player'
//import VueMasonry from 'vue-masonry-css'

const app = createApp(App)

app.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})

//app.use(BootstrapVue)
app.use(createBootstrap())
app.use(BCard).use(BCollapse)
app.use(Scrollspy)
app.use(router)
//Vue.use(VueYoutube)
//Vue.use(vueVimeoPlayer)
//Vue.use(VueMasonry)

app.mount('#app')
